var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconITimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-i-timeline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13 10 7.25 10 5.59 12 4 10 4 9 13 9 13 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17 14 11.25 14 9.59 16 8 14 8 13 17 13 17 14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.63,2.5H13.75v-2A.47.47,0,0,0,13.28,0H11.72a.47.47,0,0,0-.47.47v2h-5v-2A.47.47,0,0,0,5.78,0H4.22a.47.47,0,0,0-.47.47v2H1.88A1.88,1.88,0,0,0,0,4.38V18.13A1.88,1.88,0,0,0,1.88,20H15.63a1.88,1.88,0,0,0,1.88-1.87V4.38A1.88,1.88,0,0,0,15.63,2.5Zm-.23,15.63H2.11a.24.24,0,0,1-.23-.23V6.25H15.63V17.89A.24.24,0,0,1,15.39,18.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconITimeline);
export default __webpack_public_path__ + "static/media/icon-i-timeline.87f33c78e8d99ddd4cca77224e3967ca.svg";
export { ForwardRef as ReactComponent };